<div [dialogRef]="dialog" (appClickOutside)="close(false)">
  <kendo-dialog-titlebar (close)="close(false)">
    <i class='fa-solid fa-circle-exclamation fa-xl'></i>
    <div class="modal-title ml-8">
      <span>Error Deleting {{data?.name || ''}}</span>
    </div>
  </kendo-dialog-titlebar>
  <div class="model-body">
    <p *ngIf="bodyMessage" class="mb-16 mt-16" [innerHTML]="bodyMessage">
    </p>
    <ng-container *ngIf="data?.Branches?.length">
      <h5>Branches</h5>
      <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
        <kendo-gridlayout-item class="details" *ngFor="let branch of data?.Branches">
          <span>Branch</span>
          <p>
            <a [routerLink]="['/admin/companies/management', company?.id, 'branch', branch.id]" target="_blank"
              class="text-decoration">
              {{branch?.name}}
            </a>
          </p>
          <ng-container *ngIf="branch?.BillToBranchInvestigation?.length">
            <span>
              Bill To Branch Investigation
            </span>
            <p *ngFor="let investigation of branch?.BillToBranchInvestigation">
              <a [routerLink]="['/investigations', investigation?.id]" target="_blank" class="text-decoration">
                {{investigation?.nefcoNumber || 'Unassigned'}}
              </a>
            </p>
          </ng-container>
          <ng-container *ngIf="branch?.ClientBranchInvestigation?.length">
            <span>
              Client Branch Investigation
            </span>
            <p *ngFor="let investigation of branch?.ClientBranchInvestigation">
              <a [routerLink]="['/investigations', investigation?.id]" target="_blank" class="text-decoration">
                {{investigation?.nefcoNumber || 'Unassigned'}}
              </a>
            </p>
          </ng-container>
          <ng-container *ngIf="branch?.ContactBranchAssignments?.length">
            <span>
              Contacts
            </span>
            <p *ngFor="let branchAssignment of branch?.ContactBranchAssignments">
              <a [routerLink]="['/contacts', branchAssignment?.Contact?.id]" target="_blank" class="text-decoration">
                {{ branchAssignment?.Contact?.lastName }} {{ branchAssignment?.Contact?.firstName }}
              </a>
            </p>
          </ng-container>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </ng-container>
    <ng-container *ngIf="data?.BillingRules?.length">
      <h5>Billing Rules</h5>
      <span>
        Investigation
      </span>
      <p *ngFor="let investigation of data?.BillingRules">
        <a [routerLink]="['/investigations', investigation?.id]" target="_blank" class="text-decoration">
          {{investigation?.nefcoNumber || 'Unassigned'}}
        </a>
      </p>
    </ng-container>
    <ng-container *ngIf="data?.investigations?.length">
      <h5>Investigations</h5>
      <span>
        Investigation
      </span>
      <p *ngFor="let investigation of data?.investigations">
        <a [routerLink]="['/investigations', investigation?.id]" target="_blank" class="text-decoration">
          {{investigation?.nefcoNumber || 'Unassigned'}}
        </a>
      </p>
    </ng-container>
  </div>
  <kendo-dialog-actions layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-16" (click)="close(false)">Cancel</button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" (click)="close(true)">Okay</button>
  </kendo-dialog-actions>
</div>
